module.exports = __webpack_public_path__ + "static/media/Hangman4.8e7a4876.png";